module.exports = __webpack_public_path__ + "static/media/code_buildLogo.a974e6a9.png";